import {useShallow} from 'zustand/react/shallow';
import {QuestionModelV3} from '@albert-io/models';
import React from 'react';
import {DroppableItem} from './BankItems.react';
import useQuestionAndDrafts from '../../V2/useQuestionAndDrafts.hook';

interface Props {
  question: QuestionModelV3;
  handleItemClick: (itemId: string) => void;
  handleSlotClick: (slotId: string) => void;
}
const DropSlots = ({question, handleItemClick, handleSlotClick}: Props) => {
  const {useStoreHook} = useQuestionAndDrafts(question);

  const {wordBankItems, dropSlots, activeItemId, isDragging} = useStoreHook(
    useShallow((state) => ({
      wordBankItems: state.wordBank,
      dropSlots: state.dropSlots,
      activeItemId: state.activeItemId,
      isDragging: state.isDragging
    }))
  );

  // Helper to get items for a specific location
  const getItemsInLocation = (locationId: string | null) =>
    wordBankItems.filter((item) => item.placedInSlot === locationId);
  return (
    <div className='mcq__options-grid mt-x4 flex gap-x1'>
      {dropSlots.map((slot) => {
        const placedItem = getItemsInLocation(slot.id)[0];
        return (
          <DroppableItem
            key={slot.id}
            id={slot.id}
            value={slot.label}
            placedItem={placedItem}
            isActiveTarget={activeItemId !== null && !isDragging}
            onClick={() => handleSlotClick(slot.id)}
            onItemClick={handleItemClick}
            activeItemId={activeItemId}
            isDragging={isDragging}
          />
        );
      })}
    </div>
  );
};
export default DropSlots;
